import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import Button from '../../atoms/Button/Button'
import './Card.scss'

export class Card extends Component {

    render() {

        let className = ''

        if (this.props.isSmall) {
            className += ' card-small'
        }

        if (this.props.isFill) {
            className += ' card-fill'
        }

        if (this.props.className) {
            className += ' ' + this.props.className
        }

        let properties = {
            ...this.props
        }

        delete properties["isFill"]
        delete properties["isSmall"]

        return (

            <div {...properties} className={"card" + className} >
                {this.props.header && <div id={this.props.id + '-header'} className="card-header">{this.props.header}</div>}
                <div id={this.props.id + '-body'} className="card-body">
                    {this.props.title && <h6 id={this.props.id + '-title'} className="card-title">{this.props.title}</h6>}
                    {this.props.text && <div id={this.props.id + '-text'} className="card-text">{this.props.text}</div>}
                    {this.props.links && (
                        <div className='card-links'>
                            {this.props.links.map((link, index) =>
                                <NavLink key={`card-link-${index}`} id={this.props.id + '-' + index + '-link'} className='card-link' to={link.route}>{link.label}</NavLink>
                            )}
                        </div>
                    )}
                    {this.props.actions && (
                        <div className='card-actions'>
                            {this.props.actions.map((action, index) =>
                                <Button key={`card-action-${index}`} id={this.props.id + '-' + index + '-action'} name={action.label} className='card-action' role='link' onClick={action.onClick} />
                            )}
                        </div>
                    )}
                </div>
                {
                    this.props.footer && <div id={this.props.id + '-footer'} className="card-footer text-muted">
                        {this.props.footer}
                    </div>
                }
            </div>
        )
    }
}

export default Card
